type SVGType = {
  scale?: number;
};

export function ChatIcon({ scale = 1 }: SVGType) {
  return (
    <svg
      width={scale * 68}
      height={scale * 67}
      viewBox='0 0 68 67'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.866 0.5C42.8189 0.5 51.2194 3.93256 57.5516 10.1698C63.8838 16.407 67.3828 24.6814 67.3828 33.5C67.3828 42.3186 63.898 50.593 57.5658 56.8302C51.106 63.193 42.5214 66.5 33.8518 66.5C28.4545 66.5 23.0148 65.2163 18.0425 62.5791C13.5802 65.7465 9.21707 66.4302 6.25637 66.4302C5.15142 66.4302 4.24479 66.3326 3.60732 66.2349C2.24738 66.0256 1.1991 64.9791 0.986605 63.6395C0.774114 62.3 1.46825 61.0023 2.7007 60.4023C5.26475 59.1605 6.993 56.6767 8.06962 54.5419C-2.90906 41.5233 -2.05909 22.2256 10.1804 10.1698C16.5126 3.93256 24.913 0.5 33.866 0.5ZM18.8358 58.714C30.4803 65.4535 45.2838 63.5837 54.8459 54.1651C66.4195 42.7651 66.4195 24.2349 54.8317 12.8349C43.2722 1.43488 24.4456 1.43488 12.8719 12.8349C1.79407 23.7465 1.25576 41.3279 11.6253 52.8674C11.8945 53.1744 12.0503 53.5512 12.0928 53.9279C12.1919 54.3186 12.1636 54.7372 11.9936 55.1419C10.9312 57.5279 9.11791 60.5977 6.2422 62.6628H6.25637C8.74959 62.6628 12.5178 62.0488 16.3568 59.1186C16.3993 59.0767 16.4559 59.0349 16.5126 59.007C17.1217 58.407 18.0708 58.2674 18.8358 58.714Z'
        fill='white'
      />
      <circle cx='33.8828' cy='34' r='2.5' fill='white' />
      <circle cx='45.8828' cy='34' r='2.5' fill='white' />
      <circle cx='21.8828' cy='34' r='2.5' fill='white' />
    </svg>
  );
}

export function SearchIcon({ scale = 1 }: SVGType) {
  return (
    <svg
      width={scale * 12}
      height={scale * 12}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25969 7.9545L11.7332 10.428C11.9111 10.6059 12.0001 10.8223 12 11.077C12 11.327 11.9086 11.5433 11.726 11.726C11.5435 11.9086 11.327 12 11.077 12C10.8172 12 10.6011 11.9086 10.428 11.726L7.95448 9.25966C7.09391 9.85572 6.13477 10.1539 5.07696 10.1539C4.38952 10.1539 3.73209 10.0206 3.10464 9.75375C2.47727 9.48681 1.93633 9.12634 1.482 8.67185C1.02762 8.21752 0.66703 7.67675 0.400248 7.04937C0.133416 6.42181 0 5.76452 0 5.07708C0 4.38958 0.133416 3.73214 0.400248 3.10468C0.667055 2.4773 1.02762 1.93635 1.482 1.48202C1.93633 1.02769 2.47717 0.667064 3.10464 0.400279C3.73201 0.133418 4.38952 0 5.07696 0C5.76445 0 6.42191 0.133418 7.04946 0.400279C7.67681 0.667064 8.21757 1.02769 8.6719 1.48202C9.12622 1.93635 9.48684 2.4772 9.7536 3.10468C10.0205 3.73206 10.154 4.38958 10.154 5.07708C10.154 6.13467 9.85579 7.09398 9.25969 7.9545ZM5.07696 8.30777C5.96647 8.30777 6.72723 7.99163 7.35943 7.35932C7.99163 6.72712 8.30784 5.96644 8.30784 5.07692C8.30784 4.18756 7.99173 3.42666 7.35943 2.79452C6.72713 2.16237 5.96637 1.84615 5.07696 1.84615C4.1876 1.84615 3.42671 2.16224 2.79459 2.79452C2.16242 3.42666 1.84623 4.18756 1.84623 5.07692C1.84623 5.96644 2.16234 6.72712 2.79459 7.35932C3.42684 7.99156 4.1876 8.30777 5.07696 8.30777Z'
        fill='#B1C3DF'
      />
    </svg>
  );
}

export function EmojiIcon({ scale = 1 }: SVGType) {
  return (
    <svg
      width={scale * 22}
      height={scale * 22}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 0C4.92525 0 0 4.92525 0 11C0 17.0747 4.92525 22 11 22C17.0747 22 22 17.0747 22 11C22 4.92525 17.0747 0 11 0ZM11 1.83333C16.0545 1.83333 20.1667 5.9455 20.1667 11C20.1667 16.0545 16.0545 20.1667 11 20.1667C5.9455 20.1667 1.83333 16.0545 1.83333 11C1.83333 5.9455 5.9455 1.83333 11 1.83333ZM11.0009 14.5493C13.1386 14.5493 14.6621 13.8747 16.0481 12.7793L16.5 13.2312C15.4669 14.8078 13.5676 16.5 11.0009 16.5C8.43333 16.5 6.53308 14.8078 5.5 13.2312L5.95192 12.7793C7.33792 13.8747 8.86142 14.5493 11.0009 14.5493ZM7.79167 7.33333C7.03267 7.33333 6.41667 7.94842 6.41667 8.70833C6.41667 9.46825 7.03267 10.0833 7.79167 10.0833C8.55067 10.0833 9.16667 9.46825 9.16667 8.70833C9.16667 7.94842 8.55067 7.33333 7.79167 7.33333ZM12.8333 8.70833C12.8333 7.94842 13.4493 7.33333 14.2083 7.33333C14.9673 7.33333 15.5833 7.94842 15.5833 8.70833C15.5833 9.46825 14.9673 10.0833 14.2083 10.0833C13.4493 10.0833 12.8333 9.46825 12.8333 8.70833Z'
        fill='#D1D9E6'
      />
    </svg>
  );
}

export function FileIcon({ scale = 1 }: SVGType) {
  return (
    <svg
      width={scale * 18}
      height={scale * 21}
      viewBox='0 0 18 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2632 0H1.89474C0.852632 0 0 0.852632 0 1.89474V15.1579H1.89474V1.89474H13.2632V0ZM16.1053 3.78947H5.68421C4.64211 3.78947 3.78947 4.64211 3.78947 5.68421V18.9474C3.78947 19.9895 4.64211 20.8421 5.68421 20.8421H16.1053C17.1474 20.8421 18 19.9895 18 18.9474V5.68421C18 4.64211 17.1474 3.78947 16.1053 3.78947ZM5.68421 18.9474H16.1053V5.68421H5.68421V18.9474Z'
        fill='#D1D9E6'
      />
    </svg>
  );
}

export function MoreIcon({ scale = 1 }: SVGType) {
  return (
    <svg
      width={scale * 13}
      height={scale * 3}
      viewBox='0 0 13 3'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <circle opacity='0.498043' cx='11.5' cy='1.5' r='1.5' fill='#95A7C4' />
      <circle opacity='0.498043' cx='6.5' cy='1.5' r='1.5' fill='#95A7C4' />
      <circle opacity='0.498043' cx='1.5' cy='1.5' r='1.5' fill='#95A7C4' />
    </svg>
  );
}
